import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { type FormFieldGenerationParams } from '../../__base/generation';

export function generateToggleButtonFormField(
  params: FormFieldGenerationParams<'toggleButton'>,
): PartialPropsOf<'toggleButton'> {
  return applyPropsPatch(params.props, {
    style: { button: { offset: { margin: '$t.spacingInput', padding: '8px' } } },
  });
}
